import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-about-for-sale',
  templateUrl: './about-for-sale.component.html',
  styleUrls: ['./about-for-sale.component.scss']
})
export class AboutForSaleComponent implements OnInit {

  environment = environment;

  constructor() { }

  ngOnInit(): void {
  }
}
